import axios from 'axios';

// API client that refers to the server which hosts the app
export const api = axios.create();
